{
  "LOGIN": "Iniciar sesión",
  "REGISTER": "Registro",
  "CONF_PASS": "Confirmar contraseña",
  "CANCEL": "Cancelar",
  "SIGNUPTEXT": "Hacemos un gran seguro. ¿Podríamos cuidar de usted?",
  "FOOTER_TEXT": "MAPFRE Insurance es una marca y servicio de MAPFRE U.S.A Corp. y sus filiales. Aprender acerca",
  "OUR_COMPANIES": "Nuestras empresas",
  "PRIVACY": "Política de privacidad",
  "TERMS": "Términos y condiciones",
  "QUOTE": "Cotización",
  "CAREERS": "Empleo",
  "CONTACT": "Contacto",
  "RIGHTS": "MAPFRE U.S.A Corp. Todos los derechos reservados.",
  "EMAIL_REQUIRED": "Correo electronico es obligatorio.",
  "EMAIL_INVALID": "El correo electrónico es invalido.",
  "PASSWORD_REQUIRED": "Contraseña obligatoria.",
  "CONF_PASS_REQUIRED": "Confirmar contraseña es obligatorio.",
  "PASSWORDS_NOT_MATCH": "La contraseña y la contraseña no coinciden.",
  "FIRST_TIME": "Primera vez",
  "SIGN_IN": "Iniciar sesion",
  "CUSTOMER_ACCESS": "Acceso de clientes",
  "REMEMBER_ME": "Recuérdame",
  "FORGOT_PASS": "Recordar tu contraseña",
  "CREATE_ACCOUNT": "Crear Cuenta",    
  "SHOW_PASSWORD": "Mostrar contraseña",
  "HIDE_PASSWORD": "Ocultar contraseña",   
  "YOUR_PASSWORD_SHOULD_BE": "Su contraseña deberia ser",
  "DOES_NOT_PASS": "no pasa",
  "PASSES_THE_RULE": "pasa",
  "INVALID_USERNAME_PASSWORD": "Inválido correo electrónico y/o contraseña",
  "MODAL_HELP_TITLE": "Ayuda",
  "MODAL_HELP_CUSTOMER_PORTAL": "Su cuenta MAPFRE le permite acceder a sus documentos de poliza, informar siniestros y realizar pagos en cualquier momento.",
  "MODAL_HELP_TROUBLE_ACCESSING": "¿Tiene problemas para acceder a su cuenta?",
  "MODAL_HELP_DONT_HESITATE": "No dude en ponerse en contacto con nuestro Departamento de Atención al Cliente.",     
  "MODAL_USER_LANGUAGE_TITLE": "IDIOMA",
  "CALL_US": "Llámenos",
  "EMAIL_US": "Envíanos un email",
  "FOOTER_DEFAULT_LANGUAGE": "ESPAÑOL",    
  "FOOTER_COPY_RIGHT" : "MAPFRE U.S.A Corp. Todos los derechos reservados.",
  "FORGOT_PASSWORD_TITLE": "Olvidaste tu contraseña",
  "FORGOT_PASSWORD_PARAGRAPH": "Le enviaremos un correo electrónico con instrucciones",
  "FORGOT_PASSWORD_SUBMIT_BUTTON": "Pide nueva contraseña",
  "CHECK_YOUR_EMAIL_TITLE" : "Consulte su correo electrónico",
  "CHECK_YOUR_EMAIL_PARAGRAPH" : "Le hemos enviado un correo electrónico con instrucciones sobre cómo crear una nueva contraseña",
  "EMAIL": "Correo Electrónico",
  "PASSWORD": "Contraseña", 
  "VALID_EMAIL_VALIDATION_MESSAGE" : "Por favor introduzca una dirección de correo electrónico válida",
  "EMAIL_COULD_NOT_VALIDATE": "No pudimos validar su correo electrónico",
  "INVALID_EMAIL_PASSWORD": "Correo electrónico / contraseña inválidos",
  "CAPS_LOCK" : "Bloqueo de mayúsculas activo",
  "FORGOT_EMAIL_CONFIMATION_SUBTITLE": "¿No recibió el correo electrónico?",
  "FORGOT_EMAIL_CONFIMATION_COPY": "Revisa tu correo no deseado por un mensaje de: ",
  "FORGOT_PASS_EMAIL_SUBJECT": "MAPFRE Insurance - IMPORTANT - Reset your password",
  "FORGOT_EMAIL_SEND_AGAIN": "Enviar correo nuevo",
  "FORGOT_EMAIL_REVIEW_ME": "Por favor revise",
  "CREATE_PASSWORD": "Escriba su nueva contraseña",
  "CREATE_NEW_PASSWORD": "Crear nueva contraseña",
  "VALID_PASSWORD_VALIDATION_MESSAGE": "Contraseña incorrecta",
  "PASSWORD_RESET_CONFIRMATION_PARGRAPH": "Su contraseña fue restablecida",
  "PASSWORD_RESET_CONFIRMATION_TITLE": "Confirmación",
  "LINK_HAS_EXPIRED": "El link ha expirado",
  "LINK_HAS_EXPIRED_PARAGRAPH": "Por razones de seguridad, estos enlaces caducan después de 48 horas.",
  "REQUEST_NEW_LINK": "Solicitar un nuevo enlace",
  "TOO_MANY_ATTEMPTS_TITLE": "Demasiados intentos",
  "TOO_MANY_ATTEMPTS_PARAGRAPH": "Has alcanzado el máximo de intentos para ese correo electrónico. Por razones de seguridad, hemos bloqueado ese correo electrónico para continuar con esta acción para la próxima",
  "TIME": "24 horas",
  "FIRST_NAME": "Nombre de pila",
  "MIDDLE_INITIAL": "MI",
  "LAST_NAME": "Apellido",
  "CONTINUE": "Continuar",
  "ALL_READY_IN_USE": "ya está en uso",
  "IF_YOU_DONT_REMEMBER": "Si no recuerda haber creado una cuenta, comuníquese con nuestro Departamento de Atención al Cliente",
  "NEW_PASSWORD": "Establecer nueva contraseña",
  "ADD_POLICY_TITLE": "Encontremos su política",
  "POLICY_NUMBER": "Ingrese número de póliza",
  "I_AM_THE_POLICY_HOLDER": "Soy el titular de la póliza o una persona autorizada",
  "ADD_POLICY": "Agregar poliza",
  "MODAL_WHERE_CAN_I_LINK": "¿Dónde puedo encontrar mi número de póliza?",
  "MODAL_WHERE_CAN_I_TITLE": "Ubique su número de póliza",
  "POLICY_DOCUMENT": "Documento de política",
  "BILLING_DOCUMENT": "Factura de facturación",
  "BOP": "Política comercial detectada",
  "SERVICE_NOT_AVAILABLE": "Este servicio no está disponible en este momento.",
  "BOP_POLICIES_CANNOT_BE_ACCESS_VIA_CUSTOMER_PORTAL": "Actualmente, no se puede acceder a las políticas comerciales a través del Portal del cliente.",
  "VERIFY_ACCOUNT_TITLE": "Verifiquemos su cuenta",
  "VERIFY_ACCOUNT_WE_SENT_AN_EMAIL": "Enviamos un correo electrónico con un enlace de verificación a:",
  "VERIFY_ACCOUNT_SUBJECT_LINE": "Mapfre Insurance - IMPORTANT - Verify Your Account",
  "VERIFY_ACCOUNT_INFO_DIV": "¿No tiene acceso a su correo electrónico o quiere validar con su número de póliza?",
  "VERIFY_ACCOUNT_GO_TO_ADD_POLICY": "Verificar usando los detalles de su política",
  "NOT_FOUND": "Política no encontrada",
  "NOTFOUND_POLICY_NOT_FOUND": "La información no coincide con nuestros registros",
  "POLICY_INFO_TITLE": "Información de política solicitada",
  "POLICY_INFO_HOLDER_NAME": "Nombre del asegurado",
  "POLICY_INFO_NUMBER": "Número de póliza",
  "EDIT_POLICY_INFO": "Editar información de política",
  "TRY_AGAIN": "Inténtalo de nuevo",
  "NOTFOUND_NEED_ASSISTANCE": "Si necesita asistencia personal, comuníquese con nuestro Departamento de Atención al Cliente",
  "NOTFOUND_IF_YOU_PURCHASE": "Si compró su póliza en los últimos 2 días, aún puede estar procesando. ¡Lo siento por los inconvenientes ocasionados!",
  "TRY_AGAIN_WITH_A_DIFFERENT": "Prueba con otra política",
  "EDIT_POLICY": "Revisa tus detalles",
  "EDITPOLICY_REVIEW_POLICY": "Revise la información de su póliza y confirme.",
  "CONFIRM": "CONFIRMAR DETALLES",
  "POLICYBELONGS_TO_ANOTHER": "Política encontrada",
  "POLICYBELONGS_INFO_TITLE": "Verifica que eres el propietario de esta política",
  "POLICYBELONGS_TYPE_NUMBER_PERSONAL": "Personal",
  "POLICYBELONGS_TYPE_NUMBER_BIZ": "Negocio",
  "HOME": "Casa",
  "EFFECTIVE_DATE": "Fecha efectiva",
  "POLICYBELONGS_LEGAL": "Al hacer clic en continuar, confirma que posee la política especificada anteriormente o que el titular de la póliza le ha autorizado a actuar en su nombre con respecto a dicha política.",
  "POLICYBELONGS_AUTHORIZED": "Continuar",
  "REVIEW_POLICY_TITLE": "Bienvenido a su cuenta MAPFRE",
  "REVIEWPOLICY_INFO_TITLE": "Aquí está su información de política",
  "REVIEWPOLICY_WALLETCARD": "Agregue su tarjeta Mapfre a su teléfono",
  "VALID_NAME_VALIDATION_MESSAGE": "Por favor usa un nombre válido",
  "VALID_POLICY_VALIDATION_MESSAGE": "Por favor ingrese un número de póliza válido",
  "CREATE_ACCOUNT_LEGAL_ONE": "Al hacer clic en CONTINUAR, confirma que ha leído y acepta nuestros ",
  "CREATE_ACCOUNT_LEGAL_TWO": "Términos y Condiciones",
  "CREATE_ACCOUNT_LEGAL_THREE": "y nuestra",
  "CREATE_ACCOUNT_LEGAL_FOUR": "Política de Privacidad.",
  "CAUTION_CREATE_ACCOUNT": "En este momento, un correo electrónico no puede tener 20 caracteres.",
  "SUCCESS_FORGOT_PASSWORD": "Contraseña actualizada con éxito",
  "BACK":"espalda",
  "PASSWORD_RULE_ONE": "Ser una mezcla de letras minúsculas y mayúsculas",
  "PASSWORD_RULE_TWO": "Tener al menos 1 número",
  "PASSWORD_RULE_THREE": "Tener al menos 1 personaje especial (como @,!, $)",
  "PASSWORD_RULE_FOUR": "Tener al menos 7 caracteres de largo",
  "PASSWORD_RULE_FIVE": "A lo sumo 24 caracteres de largo",
  "AUTO": "Auto",
  "BALANCE": "Equilibrar",
  "NO_PAYMENTS_DUE": "No hay pagos debidos",
  "OUTSTANDING_BALANCE": "Saldo pendiente",
  "NEXT": "Siguiente",
  "PAY_NOW": "Pague ahora",
  "Details_Billing_Documents": "Detalles, facturación y documentos",
  "PROPERTY": "Propiedad",
  "TO": "a",
  "INACTIVE": "Inactivo",
  "ACTIVE": "Activo",
  "MORE": "Más",
  "BEEN_IN_AN_ACCIDENT": "¿Has estado en un accidente?",
  "REPORT_A_CLAIM": "Reportar Siniestro",
  "OR_CALL_US": "o llámenos",
  "MY_INSURANCE": "Mi seguro",
  "BILLING": "Facturación",
  "CLAIMS": "Reclamaciones",
  "INFORMATION": "Información",
  "ACCOUNT": "CUENTA",
  "PROFILE_AND_SETTINGS": "Configuración de perfil",
  "LOGOUT": "CERRAR SESIÓN",
  "DETAILS":"Detalles",
  "DOCUMENTS":"Documentos",
  "DOWNLOAD":"DESCARGAR",
  "VEHICLES":"Vehículos",
  "ODOMETER_UPDATE":"Manteniendo su odómetro actualizado puede ser eligible para",
  "NEW_DISCOUNTS":"nuevos descuentos",
  "LAST_UPDATE":"Última actualización",
  "UPDATE_MILEAGE":"Actualizar el kilometraje de mi vehículo",
  "LEGAL":"Nuestra empresa utilizará los datos de inspección de vehículos del Registro de Vehículos Motorizados para determinar el kilometraje anual, cuando sea posible. La diferencia es que las dos lecturas de odómetro más recientes informadas por el Registro en los últimos 24 meses, si son con una diferencia de al menos seis meses, se anualizarán para determinar el kilometraje anual. Si hay una lectura de odómetro disponible a través del Registro de Vehículos Motorizados dentro de los últimos 24 meses en el momento de la verificación, la lectura de odómetro actual proporcionada anteriormente se utilizará para anualizar el kilometraje.",
  "LEGAL_CHECKMARK":"Por la presente certifico que la información proporcionada es precisa.",
  "POLICY_HOLDER":"Los titulares de pólizas",
  "POLICY_HOLDER_ONE":"Usa tu",
  "POLICY_HOLDER_TWO":"documentos de política",
  "POLICY_HOLDER_THREE":"para comprobar todos los controladores cubiertos en esta política.",
  "PRIMARY":"Primario",
  "SECONDARY":"Secundario",
  "YOUR_AGENT":"Su agente",
  "PHONE":"Telefono",
  "ENTER_PHONE": "Ingresa tu telefono",
  "PAPERLESS":"Sin Pape",
  "ENROLL_NOW_COPY": "Inscríbase en nuestro plan E-Pay (Autopay)",
  "PAPERLESS_PARTIAL":"Terminar de inscribirse en Paperless para calificar",
  "AMOUNT_TO_SAVE":"Puede ahorrar hasta un 10%",
  "ENROLL_NOW":"Enlístate ahora",
  "ENROLL_EPAY": "Enlístate ahora",
  "ENROLLED":"¡Estás inscrito!",
  "ADDRESS":"Dirección",
  "MAILING":"Envío",
  "RESIDENTIAL":"Residencial",
  "SAME_AS_MAILING":"Misma que la dirección de correo",
  "PROPERTY_COVERED":"Propiedad cubierta",
  "APARTMENT":"Apartamento (opcional)",
  "INFORMATION_RENEWAL_ONE":"Con la renovación automática, no se quedará con un lapso de seguro debido a que su póliza caducará sin saberlo. Todo lo que se requiere es el pago en su factura de renovación y ¡ya está todo listo! A continuación se detallan los pasos del proceso junto con las consideraciones que tal vez desee analizar con su agente.",
  "INFORMATION_RENEWAL_TWO":"Política de revisión",
  "INFORMATION_RENEWAL_THREE":"45-60 días antes de su fecha de renovación, su paquete de renovación MAPFRE llega. Su política le será enviada por correo (enviada por correo electrónico a nuestros clientes de ePolicy). Revise su política para ver si se debe cambiar algo.",
  "INFORMATION_RENEWAL_FOUR":"¿Por qué cambió mi tarifa?",
  "INFORMATION_RENEWAL_FIVE":"Cuando reciba su oferta de renovación, puede notar que su tarifa ha cambiado. Esto puede suceder por varias razones.",
  "INFORMATION_RENEWAL_SIX":"Eventos de la vida",
  "INFORMATION_RENEWAL_SEVEN":"Debido a que la tasa de su seguro de automóvil se basa principalmente en factores específicos para usted, ciertos cambios en su vida podrían afectar su tasa. Por ejemplo, los cambios en su nivel de cobertura, deducibles o kilometraje anual podrían aumentar o disminuir su prima. Además, si ha movido, agregado o eliminado un conductor, o cambiado el automóvil que conduce, también podría ver alguna fluctuación en la cantidad que paga.",
  "INFORMATION_RENEWAL_EIGHT":"Experiencia de manejo",
  "INFORMATION_RENEWAL_NINE":"Las compañías de seguros establecen su prima en gran medida en función del riesgo. Su historial de manejo es un buen indicador de su riesgo para asegurar (en otras palabras, la probabilidad de que cause un accidente).",
  "INFORMATION_RENEWAL_TEN":"Accidentes",
  "INFORMATION_RENEWAL_ELEVEN":"Contrariamente a lo que se cree, no todos los reclamos de accidentes y seguros de automóviles aumentarán su tasa. Un accidente puede hacer que su tarifa aumente, pero depende de varios factores (como la gravedad del incidente, su historial de manejo y si tuvo la culpa).",
  "INFORMATION_RENEWAL_TWELVE":"Pagar la factura",
  "INFORMATION_RENEWAL_THIRTEEN":"Pague su factura de renovación antes de la fecha de vigencia de la política para evitar la cancelación.",
  "INFORMATION_RENEWAL_FOURTEEN":"Si ya tiene configurados los pagos automáticos, su pago se retirará automáticamente.",
  "INFORMATION_RENEWAL_15":"¿Cambiar los métodos de pago?",
  "INFORMATION_RENEWAL_16":"Inicie sesión en su política para actualizar su método de pago o comuníquese con nuestro Departamento de Servicio al Cliente, de lunes a viernes, de 8 a.m. a 6 p.m.",
  "INFORMATION_RENEWAL_17":"¡HechO!",
  "INFORMATION_RENEWAL_18":"Con la renovación automática, es así de fácil!",
  "INFORMATION_RENEWAL_19":"¿Preguntas sobre la política o actualizaciones?",
  "INFORMATION_RENEWAL_20":"La renovación es un buen momento para revisar sus coberturas y asegurarse de que está completamente protegido.",
  "INFORMATION_RENEWAL_21":"Comuníquese con su agente si tiene preguntas o cambios en su póliza, incluso si se ha mudado.",
  "INFORMATION_RENEWAL_22": "¿No quieres renovar? Comuníquese con su agente para informarle que desea cancelar al final del plazo de la póliza. Asegúrese de tener otra cobertura en su lugar antes de cancelar.",
  "INFORMATION_HOME_1": "Sobre MAPFRE",
  "INFORMATION_HOME_2": "MAPFRE Insurance ofrece un servicio cordial desde más de 2,000 profesionales ...",
  "INFORMATION_HOME_3": "Nuestros productos",
  "INFORMATION_HOME_4": "Ofrece una amplia gama de soluciones de seguros para el hogar y el vehículo.",
  "INFORMATION_HOME_5": "Descuentos",
  "INFORMATION_HOME_6": "MAPFRE tiene una variedad de descuentos que le ayudarán a ahorrar dinero en ...",
  "INFORMATION_HOME_7": "Proceso de renovación",
  "INFORMATION_HOME_8": "Con la renovación automática, no se quedará con un lapso de seguro du ...",
  "INFORMATION_HOME_9": "Proceso de cancelación",
  "INFORMATION_HOME_10": "Si desea cancelar su póliza de automóvil, llámenos al 1-800-922-8276 ...",
  "INFORMATION_HOME_11": "Términos y condiciones legales",
  "INFORMATION_HOME_12": "Su uso de la sección de Servicios en línea de este sitio web también está sujeto a ...",
  "INFORMATION_CANCEL_1": "Proceso de cancelación",
  "INFORMATION_CANCEL_2": "Si desea cancelar su póliza de automóvil, llámenos al 1-800-922-8276, donde nuestros agentes están disponibles para ayudarlo con este proceso.",
  "INFORMATION_ABOUT_1": "Acerca de Mapfre",
  "INFORMATION_ABOUT_2": "MAPFRE Insurance ofrece un servicio cordial de más de 2,000 profesionales enfocados en cuidar de usted y su familia. Conoce nuestra presencia en todo el mundo.",
  "INFORMATION_ABOUT_3": "Presencia global",
  "INFORMATION_ABOUT_4": "MAPFRE a través del globo",
  "INFORMATION_ABOUT_5": "Parte del Grupo MAPFRE: un grupo global de seguros que opera en más de 100 países en los cinco continentes. MAPFRE tiene más de 36,000 empleados que atienden a más de 30 millones de clientes en todo el mundo.",
  "INFORMATION_ABOUT_6": "Enfoque local",
  "INFORMATION_ABOUT_7": "MAPFRE en los Estados Unidos",
  "INFORMATION_ABOUT_8": "Ofrece una amplia gama de soluciones de seguros para el hogar y el vehículo.",
  "INFORMATION_ABOUT_9": "Es la 21 aseguradora de daños a la propiedad más grande",
  "INFORMATION_ABOUT_10": "Es el vigésimo mayor asegurador privado de automóviles para pasajeros.",
  "INFORMATION_ABOUT_11": "Cuenta con una red de más de 5000 agentes y corredores independientes.",
  "INFORMATION_ABOUT_12": "Tiene presencia en 14 estados.",
  "INFORMATION_ABOUT_13": "Clasificado como 'A' (excelente) por A.M. Mejor",
  "INFORMATION_DISCOUNTS_1":"Descuentos",
  "INFORMATION_DISCOUNTS_2":"MAPFRE Insurance ofrece una multitud de descuentos para garantizar que obtenga el máximo valor de su póliza. Los descuentos en automóviles y vehículos incluyen:",
  "INFORMATION_DISCOUNTS_3":"Descuentos para miembros AAA",
  "INFORMATION_DISCOUNTS_4":"Al asegurar su automóvil, hogar y paraguas a través de nosotros, ofrecemos un descuento en el seguro de vivienda y un descuento en el seguro de automóvil.",
  "INFORMATION_DISCOUNTS_5":"Al asegurar tanto su automóvil como su hogar a través de nosotros, ofrecemos un descuento en el seguro de vivienda y un descuento en el seguro de automóvil.",
  "INFORMATION_DISCOUNTS_6":"Comprar crédito inteligente",
  "INFORMATION_DISCOUNTS_7":"Bienvenido de nuevo crédito cuando se aplica la lealtad anterior.",
  "INFORMATION_DISCOUNTS_8":"Descuento de pago completo",
  "INFORMATION_DISCOUNTS_9":"Buen descuento para estudiantes",
  "INFORMATION_DISCOUNTS_10":"Descuento de estudiante fuera de casa",
  "INFORMATION_DISCOUNTS_11":"Descuento anual de millas",
  "INFORMATION_DISCOUNTS_12":"Descuento por conductor inteligente (pregunte acerca de la capacitación en prevención de accidentes InControl o los programas de capacitación para adolescentes inteligentes)",
  "INFORMATION_DISCOUNTS_13":"Descuento Multi-Car",
  "INFORMATION_DISCOUNTS_14":"Descuento verde",
  "INFORMATION_DISCOUNTS_15":"Limpiar en tres descuentos",
  "INFORMATION_PRODUCTS_1":"Nuestros productos",
  "INFORMATION_PRODUCTS_2":"Ofrecemos una amplia gama de soluciones de seguros para el hogar, el vehículo y cualquier otra cosa que desee proteger.",
  "INFORMATION_PRODUCTS_3":"Auto",
  "INFORMATION_PRODUCTS_4":"Consigue una cotización",
  "INFORMATION_PRODUCTS_5":"Propiedad",
  "INFORMATION_PRODUCTS_6":"Vida",
  "INFORMATION_PRODUCTS_7":"Viajar",
  "INFORMATION_PRODUCTS_8":"Negocio",
  "INFORMATION_PRODUCTS_9":"Paraguas",
  "INFORMATION_PRODUCTS_10":"Motocicleta",
  "INFORMATION_PRODUCTS_11":"Embarcaciones",
  "INFORMATION_PRODUCTS_12":"Rec. Vehículo",
  "INFORMATION_LEGAL_1":"Términos y condiciones legales",
  "INFORMATION_LEGAL_2":"MAPFRE USA y sus afiliadas, American Commerce Insurance Company℠ (Columbus, Ohio); Citation Insurance Companyitation (Webster, MA); The Commerce Insurance Company℠ (Webster, MA); Commerce West Insurance Company℠ (California COA No. 06715; San Ramon, CA): MAPFRE Insurance Company℠ (California COA No. 18643; Florham Park, NJ); y MAPFRE Insurance Company of New York℠ (Garden City, NY), aseguran automóviles privados de pasajeros y ofrecen seguros para propietarios de viviendas y otros tipos para solicitantes calificados. Las empresas se comercializan colectivamente bajo la marca de servicio y la marca MAPFRE Insurance ('Compañía'). No todas las compañías tienen licencia para hacer negocios en todos los estados. No todos los productos están disponibles en todos los estados.",
  "INFORMATION_LEGAL_3":"El uso de este sitio web se rige y está sujeto a estos Términos y condiciones. AL UTILIZAR LOS SERVICIOS DISPONIBLES EN ESTE SITIO WEB, ESTÁ INDICANDO QUE SU ACUERDO ESTÁ OBLIGADO POR TODOS ESTOS TÉRMINOS Y CONDICIONES.",
  "INFORMATION_LEGAL_4":"El uso de la sección de Servicios en línea de este sitio web también está sujeto a los Términos y condiciones de los Servicios en línea que aparecen a continuación. El término 'Términos y condiciones', tal como se utiliza en este documento, incluye tanto los Términos y condiciones generales como los Términos y condiciones de los servicios en línea.",
  "INFORMATION_LEGAL_5":"Este sitio web presenta información y contenido que es propiedad o está autorizado por la Compañía. Cuando se utiliza en estos Términos y condiciones, 'nosotros', 'nuestro' y 'nosotros' significan la Compañía.",
  "INFORMATION_LEGAL_6":"Cambios",
  "INFORMATION_LEGAL_7":"El contenido de este sitio web y estos Términos y condiciones están sujetos a cambios o actualizaciones por parte de la Compañía en cualquier momento sin previo aviso. Los cambios pueden incluir términos y condiciones sustitutivos o avisos específicos. DEBE REVISAR ESTOS TÉRMINOS Y CONDICIONES DE MISMO TIEMPO PARA SER CONSCIENTES DE CUALQUIER CAMBIO QUE SE REALICE. SU USO CONTINUO DE ESTE SITIO WEB CONSTITUYE SU ACEPTACIÓN DE CUALQUIER CAMBIO O ACTUALIZACIÓN, TODO LO QUE SERÁ CONTROLANDO CUANDO SE PUBLIQUE.",
  "INFORMATION_LEGAL_8":"Uso del sitio por parte de no estadounidenses. Personas",
  "INFORMATION_LEGAL_9":"La Compañía no afirma que el contenido de este sitio web sea apropiado o que pueda descargarse fuera de los Estados Unidos. El acceso al contenido puede no ser legal para ciertas personas o en ciertos países. Si accede al sitio desde fuera de los Estados Unidos, lo hace bajo su propio riesgo y es responsable de cumplir con las leyes de su jurisdicción.",
  "INFORMATION_LEGAL_10":"Política de privacidad",
  "INFORMATION_LEGAL_11":"Su información de identificación personal que podamos recopilar está sujeta a nuestra Política de privacidad, que se incorpora a estos Términos y condiciones por referencia.",
  "INFORMATION_LEGAL_12":"Decisiones financieras",
  "INFORMATION_LEGAL_13":"Al igual que con todos los asuntos financieros, debe tener mucho cuidado al usar la información proporcionada en este sitio web o disponible a través de los enlaces de este sitio web. Ninguna parte de este sitio web debe interpretarse como un asesoramiento fiscal, legal, de inversión o contable.",
  "ACTIVE_CLAIMS":"Reclamaciones activas",
  "DATE_OF_LOSS": "Fecha de la pérdida",
  "CLOSED": "Cerrado",
  "CLOSED_CLAIMS":"Reclamaciones Cerradas",
  "CLAIM_DETAILS":"Detalles de la reclamación",
  "REPORT_CTA":"¿Ha tenido un accidente u otra pérdida? Estamos aquí para usted 24/7/365.",
  "OR_CALL_US_AT":"O llámenos al",
  "REPORT_CLAIM_HERE":"Siempre aqui para ti 24/7",
  "CLAIM_FAQ_1": "Preguntas frecuentes sobre informes de reclamaciones",
  "CLAIM_FAQ_2": "¿Qué debo esperar?",
  "CLAIM_FAQ_3": "Un representante reunirá información detallada sobre su pérdida y la ingresará electrónicamente en nuestro sistema. El informe de reclamación debe tomar sólo 10-15 minutos.",
  "CLAIM_FAQ_4": "¿Cómo funcionan las tasaciones?",
  "CLAIM_FAQ_5": "Durante el informe inicial, crearemos una evaluación para usted. Por lo tanto, es útil tener la ubicación del vehículo cuando llama en la pérdida. Un Ajustador de Daños Físicos necesitará la evaluación para procesar y resolver su reclamo. Vea nuestra sección de ayuda para aprender más.",
  "CLAIM_FAQ_6": "¿Qué pasa si alguien resultó herido?",
  "CLAIM_FAQ_7": "Si alguien resultó lesionado en el accidente, crearemos una reclamación y asignaremos un Ajustador de siniestros. Esta persona será responsable de la resolución de cualquier reclamación por lesiones.",
  "CLAIM_FAQ_8": "¿Quién está manejando mi reclamo?",
  "CLAIM_FAQ_9": "Cuando nos comunique su reclamo, nuestros Representantes del Centro de Servicio de Reclamaciones trabajarán con usted para recopilar la información y le asignarán un Representante de Reclamaciones para que se encargue de sus necesidades. Además, para las reclamaciones de automóviles, se asignará un tasador de seguros de MAPFRE para inspeccionar su vehículo y escribir una evaluación de daños.",
  "CLAIM_FAQ_10": "¿Puedo alquilar un coche?",
  "CLAIM_FAQ_11": "Si su póliza incluye cobertura para un vehículo sustituto, y su vehículo no es manejable o no está en la tienda para reparaciones, su Representante de reclamaciones lo ayudará a obtener un vehículo de alquiler. MAPFRE Insurance tiene una lista de compañías de alquiler preferidas entre las que puede elegir.",
  "CLAIM_FAQ_12": "¿Cómo manejo las reparaciones de emergencia?",
  "CLAIM_FAQ_13": "A veces, un reclamo de propiedad requiere atención inmediata, como limpieza de emergencia o arreglos de alojamiento temporal si su hogar no es habitable. Tenemos miembros del personal disponibles para coordinar los arreglos para atender su situación de emergencia lo más rápido posible.",
  "NO_CLAIMS_CTA":"Bien hecho, mantente seguro ✌️ ",
  "CLAIMANT": "Demandante",
  "PAYMENTS_TO_DATE": "Pagos a la fecha",
  "LOCATION": "Ubicación",
  "DESCRIPTION": "Descripción",
  "CLAIMANT_ADJUSTER": "Ajustador de reclamaciones",
  "FAX": "fax",
  "APPRAISAL_INFORMATION": "Información de valoración",
  "NUMBER": "Número",
  "APPRAISER": "Tasador",
  "AMOUNT": "Cantidad",
  "STATUS": "Estado",
  "PAYMENT_INFORMATION": "Información del pago",
  "CHECK": "Cheques",
  "DATE_PAID": "Fecha de pago",
  "MODAL_MAKE_A_PAYMENT": "REALIZAR UN PAGO",
  "PAY_BY_CHECK": "PAGAR POR CUENTA DE CHEQUES",
  "PAY_BY_CREDIT_CARD": "PAGO CON TARJETA DE CRÉDITO / DÉBITO",
  "SELECT_AMOUNT":"Seleccione la cantidad",
  "MINIMUM_AMOUNT_DUE":"Monto mínimo de pago",
  "OUTSTANDING_POLICY_BALANCE":"Saldo de la política pendiente",
  "OTHER_AMOUNT":"Otra cantidad",
  "ENTER_AMOUNT":"Ingrese la cantidad",
  "CHECKING_ACCOUNT":"Cuenta de cheques",
  "EDIT":"Editar",
  "ACCOUNT_HOLDER":"Titular de la cuenta",
  "ACCOUNT_NUMBER":"Número de cuenta",
  "CHECK_NUMBER":"Número de cheque (opcional)",
  "ACCOUNT_HOLDERS_NAME":"Nombre del titular de la cuenta",
  "BANK_ROUTING_NUMBER":"Número de ruta bancaria",
  "CONFIRM_BANK_ACCOUNT_NUMBER":"Confirmar el número de cuenta bancaria",
  "STORE_INFORMATION":"Almacene esta información para futuros pagos únicos",
  "CHECK_NUMBER_OPTIONAL":"Número de cheque (opcional)",
  "PAYMENT_LEGAL":"Al enviar este pago en línea, está autorizando a The Commerce Insurance Company (parte del Grupo MAPFRE) a imprimir un cheque de su cuenta con la información que se proporciona anteriormente. También está certificando que está autorizado para permitir este pago de la cuenta.",
  "CONFIRM_PAYMENT":"Confirmar pago",
  "MAILING_ADDRESS":"Dirección de envio",
  "HOLDER_NAME":"Nombre del titular",
  "ROUTING_NUMBER":"Número de ruta",
  "BANK_ACCOUNT_NUMBER":"Número de cuenta bancaria",
  "PAYMENT_AMOUNT":"Monto del pago",
  "REVIEW_PAYMENT":"Revisar el pago",
  "MAKE_A_CHECK_PAYMENT":"Hacer un pago con cheque",
  "BILLING_QUESTIONS":"PREGUNTAS DE FACTURACION",
  "QUESTIONS_ABOUT_POLICY":"¿Tiene una pregunta de facturación sobre esta política?",
  "CONTACT_BILLING_REP":"Póngase en contacto con su representante de facturación",
  "YOUR_EMAIL_ADDRESS": "Tu correo electrónico",
  "YOUR_COMMENTS": "Tus comentarios",
  "BILLING_PAR_ONE": "No puede realizar cambios en sus pólizas o coberturas utilizando este sistema. Para estas inquietudes por favor contacte a su agente de seguros independiente.",
  "BILLING_PAR_TWO": "Solo podemos responder a las consultas por correo electrónico de un asegurado nombrado en esta póliza.",
  "MODAL_POLICY_NUMBER": "Número de póliza",
  "MODAL_BILL_REP": "Representante de facturación",
  "MODAL_BILLING_REP_HELP_TITLE":"Contactar Representante",
  "CONTACT_YOUR_BILLING_REP": "Póngase en contacto con su representante de facturación",
  "SCHEDULED_PAYMENTS":"Facturas programadas",
  "HISTORY": "Historial de facturación",
  "DUE_DATE": "Fecha de vencimiento",
  "DATE": "Fecha",
  "BILLING_OVERVIEW": "Resumen de facturación",
  "CUSTOMER_BALANCE": "Saldo del cliente",
  "NO_PAYMENTS":"¡No hay pagos debidos!",
  "ENROLL_IN_OUR_PAPERLESS_PLAN":"Inscríbase en nuestro plan sin papel",
  "AND_SAVE_UP_TO_3%":"Y obtén descuentos!",
  "SETTINGS":"Ajustes",
  "PAPERLESS_ONE": "¡Ir sin papel agiliza la entrega de sus documentos y la publicación de sus pagos, así como ayuda al medio ambiente!",
  "PAPERLESS_TWO": "No importa dónde se encuentre, su información de facturación y política está disponible a través de su cuenta en línea.",
  "PAPERLESS_THREE": "Combine e-Policy, e-Pay & e-Bill",
  "PAPERLESS_THREE-STRONG": "y obtén descuentos!",
  "PAPERLESS_FOUR": "Vamos a inscribirnos",
  "E-POLICY": "e-Policy",
  "E-PAY": "e-Pay",
  "E-BILL": "e-Bill",
  "PAPERLESS_SIX": "Ver los documentos de su póliza en línea.",
  "PAPERLESS_SEVEN": "Ver sus facturas en línea (pasado y presente) para aquellas políticas que no están inscritas en e-Bill.",
  "ARE_YOU_SURE_YOU_WANT_TO_REMOVE_POLICY": "¿Estás seguro de que quieres eliminar la política?",
  "FROM_E-POLICY": "de e-Policy?",
  "FROM_E-BILL": "de e-Bill?",
  "FROM_E-PAY": "de e-Pay?",
  "PAPERLESS_NINE": "QUITAR DE LA E-POLICY",
  "PENDING_ENROLLMENT": "Inscripción pendiente",
  "PENDING_REMOVAL": "Remoción pendiente",
  "REMOVE_FROM_E-POLICY": "QUITAR DE LA E-POLICY",
  "REMOVE_FROM_E-PAY": "QUITAR DE LA E-PAY",
  "REMOVE_FROM_E-BILL": "QUITAR DE LA E-BILL",
  "CONFIRM_ENROLLMENT": "Confirmar la inscripción",
  "PAPERLESS_EIGHT": "Establecer Autopay - Electronic Funds Transfer (EFT) y olvidarse de los pagos.",
  "POLICIES_ELEGIBLE": "Políticas Eligibles",
  "EPOLICY_ONE":"e-Policy le permite ver sus documentos en línea en cualquier momento.",
  "EPOLICY_TWO":"Recibirá una notificación por correo electrónico cada vez que haya un nuevo documento disponible.",
  "EPOLICY_THREE":"¡Combínelo con e-PAY o e-BILL para obtener nuestro descuento sin papel!",
  "ENROLLED_TEXT": "Inscrito",
  "EPAY_ONE":"e-Pay o Autopay es nuestra opción de pago mediante Transferencia electrónica de fondos (EFT).",
  "EPAY_TWO":"Se realiza automáticamente para usted cada mes.",
  "EPAY_THREE":"¡Combínelo con e-POLICY para obtener nuestro descuento sin papel!",
  "EPAY_ENROLL_TITLE":"e-Pay inscripción",
  "EPAY_ENROLL_PARA":"Agregue su cuenta corriente o de ahorros para inscribir su póliza en el pago automático",
  "EPAY_CONFIRM_ONE":"Su póliza está ahora inscrita en e-PAY",
  "EPAY_CONFIRM_TWO":"Su programa de deducción de pago automático se le enviará por correo 2 semanas antes de su primera deducción. Su cuenta reflejará sus actualizaciones dentro de 1 a 2 días hábiles. ",
  "EPAY_CONFIRM_TWO_STRONG":" La deducción estimada puede no incluir ningún aumento o disminución en las primas debido a la eliminación de descuentos o cambios en la política.",
  "TYPE_OF_ACCOUNT": "Tipo de cuenta",
  "ROUTING/AB":"Routing/ABA Numero",
  "MONTHLY_DEDUCTION_DATE":"Fecha de deducción mensual",
  "UPDATE":"actualizar",
  "ENROLL_TO_SEND_EBILL":"Inscríbase para enviar factura electrónica",
  "EBILL_ONE":"e-Pay o Autopay es nuestra opción de pago mediante Transferencia electrónica de fondos (EFT).",
  "EBILL_TWO":"Se realiza automáticamente para usted cada mes.",
  "EBILL_THREE":"¡Combínelo con e-POLICY para obtener nuestro descuento sin papel!",
  "MODAL_E-BILL-ENROLL_TITLE":"E-BILL ENROLL",
  "MODAL_E-POLICY-ENROLL_TITLE":"E-POLICY ENROLL",
  "MODAL_E-PAY-ENROLL_TITLE":"E-PAY ENROLL",
  "MODAL_E-POLICY-REMOVAL_TITLE":"E-POLICY REMOVAL",
  "MODAL_E-PAY-REMOVAL_TITLE":"E-PAY REMOVAL",
  "MODAL_E-BILL-REMOVAL_TITLE":"E-BILL REMOVAL",
  "MODAL_REMOVAL_TITLE":"Eliminación de la política",
  "MODAL_REMOVAL_TITLE_PAPERLESS":"RETIRAR DEL PAPEL",
  "MODAL_ENROLL_TITLE": "INSCRIPCIÓN A LA POLÍTICA",
  "PLEASE_CONFIRM_YOUR_REQUEST_TO_ENROLL_POLICY":"Por favor confirme su solicitud de inscripción política",
  "IN_E-POLICY": "en e-Policy?",
  "IN_E-BILL": "en e-Bill?",
  "IN_E-PAY": "en e-Pay?",
  "PAPERLESS_SETTINGS": "Configuraciones Sin Papel",
  "HAVE_OTHER_MAPFRE_POLICIES_NOT_LISTED_HERE":"¿Tiene otras políticas de MAPFRE que no figuran aquí?",
  "ADD_YOUR_POLICY":"Agregar número de póliza",
  "ADD_NEW_POLICY_TITLE": "Añadir nueva política",
  "YOUR_CURRENT_EMAIL_IS": "Tu correo electrónico actual es",
  "PROFILE_CHECKING_ACCOUNT": " La actualización de su cuenta de cheques almacenada no actualizará ninguna información sobre sus cuentas de cheques en nuestro sitio de factura electrónica.",
  "PROFILE_CHECKING_ACCOUNT_SAVE":"Save checking account",
  "PROFILE_CHECKING_ACCOUNT_MODAL_ONE":"Si vuelves perderás todo tu progreso.",
  "PROFILE_CHECKING_ACCOUNT_MODAL_TWO":"Are you sure that you want to remove all Checking account information?",
  "PROFILE_EMAIL_ONE":"Introduzca una nueva dirección de correo electrónico",
  "PROFILE_EMAIL_TWO":"Cambiar dirección de correo electrónico",
  "PROFILE_EMAIL_THREE":"Primero, ingrese su contraseña actual",
  "PROFILE_PASSWORD_TITLE":"Cambia tu contraseña",
  "PROFILE_PASSWORD_ONE":"Antes de continuar, verifique su contraseña",
  "PROFILE_PASSWORD_TWO":"Vamos a crear tu nueva contraseña",
  "SEND_EMAIL_AGAIN":"Enviar correo electrónico de nuevo",
  "PROFILE_EMAIL_CONF_ONE":"Importante",
  "PROFILE_EMAIL_CONF_TWO":"Por favor, confirme que el nuevo correo electrónico es correcto. Después de confirmar, el anterior ya no será válido para iniciar sesión en su cuenta.",
  "PROFILE_EMAIL_CONF_THREE":"Nuevo Email",
  "PROFILE_EMAIL_CONF_FOUR":"Confirme nuevo correo electrónico",
  "PROFILE_EMAIL_CONF_FIVE":"Revisa tu spam para un mensaje con el asunto:",
  "PROFILE_MAIN_ONE":"Mi cuenta",
  "PROFILE_MAIN_TWO":"Cambia la contraseña",
  "PROFILE_MAIN_THREE":"Añade más seguridad a tu cuenta",
  "PROFILE_MAIN_FOUR":"Cuenta de cheques / ahorro",
  "PROFILE_MAIN_FIVE":" Ahorre tiempo y esfuerzo en sus pagos.",
  "PROFILE_MAIN_SIX":"Cuenta de cheques",
  "PROFILE_MAIN_SEVEN": "Tu billetera digital",
  "PROFILE_CARDS": "Gestiona tus tarjetas de crédito y débito",
  "PROFILE_PHONE_ONE":"Actualizar número de teléfono",
  "PROFILE_PHONE_TWO":"Agregar el número de teléfono",
  "PAYMENT_HISTORY":"Historial de facturación",
  "PENDING_CHECKS":"Pending Checks",
  "NO_DOCUMENTS_TITLE":"No hay documentos disponibles todavía",
  "NO_DOCUMENTS_PARAGRAPH":"La pestaña de documentos enumerará las páginas de selección de cobertura disponibles y le permitirá verlas, imprimirlas y guardarlas.",
  "SAVE_TIME_AND_MONEY":"¡Ahorra tiempo y dinero!",
  "NEW_AND_EXISTING_CLAIMS":"Reclamaciones nuevas y existentes",
  "BILLING_CUSTOMER_SERVICE_QUOTES":"Facturación, Servicio al Cliente y Cotizaciones",
  "FOLLOW_US":"Síguenos",
  "CONTACT_YOUR_AGENTS":"Póngase en contacto con sus agentes",
  "FOR_POLICY_CHANGES_COVERAGES_DISCOUTS":"Para cambios de póliza, coberturas y descuentos.",
  "ACCOUNT_NUMBER_CONFIRM_DO_NOT_MATCH":"Account Number and Confirm Bank Account Number does not match",
  "NOT_IN_A_VALID_FORMAT":"Your input is not in a valid format. example 111.11 or 111",
  "THIS_AMOUNT_IS_LESS_THAN_YOU_MIN":"La cantidad que ingresa es menor que la cantidad mínima adeudada – ",
  "CHECKING_YOU_KNOW_THAT_AMOUNT_IS_LESS_THAN_MIN_AMOUNT":"By checking this, you recognize that the amount you are sending is less than the Minimum amount due.",
  "LESS_THAN_MIN_AMOUNT": "The Amount you are sending is less then the Minimum Amount Due",
  "REMOVE_CHECKING_ACCOUNT":"QUITAR CUENTA BANCARIA  ",
  "DISCARD_CHANGES":"DESCARTAR LOS CAMBIOS",
  "STAY_HERE":"QUÉDATE AQUÍ",
  "CONFIRM_EMAIL":"confirme nuevo correo electrónico",
  "LETS_VERIFY_YOUR_ACCOUNT":"Verifiquemos tu cuenta",
  "EMAIL_VERIFICATION_SUBJECT_TITLE":"Hemos enviado un correo electrónico con enlace de verificación a",
  "RESEND_VERIFICATION_EMAIL":"Reenviar correo electrónico de verificación",
  "DID_NOT_RECEIVE_EMAIL":"¿No recibió el correo electrónico?",
  "CHECK_YOUR_SPAM_MESSAGES":"Revisa tu spam para un mensaje con el asunto",
  "CHECKING_ACCOUNT_INFO_UPDATED":"La información de la cuenta corriente se actualiza con éxito.",
  "ERROR_CHECKING_INFO":"Hubo un problema con la actualización de su cuenta de cheques.",
  "PLEASE_ENTER_VALID_ADDRESS":"Por favor, introduzca una dirección válida de sugerencias",
  "CHANGE_ADDRESS_ALERT_SUCCESS":"Su solicitud de cambio de dirección fue enviada.",
  "CHANGE_ADDRESS_ALERT_ERROR":"No podemos actualizar la dirección.",
  "INVALID_CHANGE_PASSWORD": "Contraseña incorrecta",
  "CANCELLED": "CANCELADO",
  "NOT_ELEGIBLE" : "Not Eligible",
  "SUBJECT_EMAIL": "MAPFRE Seguro - Por favor activa tu cuenta",
  "AVAILABLE_24_7": "Siempre aqui para ti 24/7",
  "BANK_ACCOUNT_HOLDER_NAME_VALIDATION": "Por favor ingrese un nombre valido.",
  "BANK_ROUTING_NUMBER_VALIDATION": "Por favor ingrese un número de ruta válido.",
  "BANK_ACCOUNT_NUMBER_VALIDATION": "Por favor ingrese un número de cuenta válido.",
  "EPAY_ENROLL_LEGAL":"I authorize MAPFRE U.S.A. Corp. and its subsidiaries* (“MAPFRE”) to initiate scheduled deductions from the bank account identified above for payment of premium and any associated fees on the insurance policy issued to me by MAPFRE, any subsequent replacement policy issued by MAPFRE, and any renewals thereof (the “Policy”); and to initiate credit entries to the account to correct any erroneous deductions or provide a refund of premium.  Further, I authorize and request that funds be withdrawn from the account as payments become due under the Policy. I understand the payment amount may vary as a result of changes to and/or renewal of the Policy. I understand that a fee may apply and be added to each withdrawal where permitted by law; and that a fee will be charged for all returned payments. This authorization will remain in effect until MAPFRE receives written notice from me of its termination, in such time and manner as to afford MAPFRE a reasonable opportunity to act on it. MAPFRE reserves the right to terminate this payment plan and/or my participation in it at any time. * MAPFRE U.S.A. Corp. and its subsidiaries, American Commerce Insurance Company (Columbus, OH); Citation Insurance Company (Webster, MA); The Commerce Insurance Company (Webster, MA); Commerce West Insurance Company (San Ramon, CA); MAPFRE Insurance Company (Florham Park, NJ); and MAPFRE Insurance Company of New York (Garden City, NY).",
  "SURCHARGES_MAY_APPLY": "Pueden aplicarse recargos",
  "FIRST_NAME_AS_PASSWORD_ERROR": "Evita tu nombre como parte de la contraseña.",
  "LAST_NAME_AS_PASSWORD_ERROR": "Evita tu apellido como parte de la contraseña.",
  "TOO_MANY_IDENTICAL_CHARACTER": "demasiados personajes idénticos.",
  "GREATER_THAN_MIN_AMOUNT": "Mayor que la cantidad mínima",
  "NOT_YOU": "No tú?",
  "GOOD_MORNING": "Buenos días",
  "GOOD_AFTERNOON": "Buenas tardes",
  "GOOD_EVENING": "Buena noches",
  "THIS_AMOUNT_IS_GREATER_THAN_OUTSTANDING":"Ingrese una cantidad igual o menor que su saldo",
  "POLICY_LINKED_TO_ANOTHER_EMAIL": "Política vinculada a otro correo electrónico.",
  "POLICY_LINKED_TO_ANOTHER_EMAIL_DISCRIPTION": "Por favor revise sus detalles o contáctenos para solucionar sus problemas de correo electrónico.",
  "REVIEW_DETAILS_LINK" : "Detalles de la revisión",
  "POLICY_LINKED_TO_ANOTHER_EMAIL_PERSONAL_ASSISTANCE":"Si necesita asistencia personal, comuníquese con nuestro Departamento de Servicio al Cliente llamando al",
  "POLICY_LINKED_TO_ANOTHER_EMAIL_SEND_US_EMAIL" : "enviándonos un email",
  "POLICY_LINKED_TO_ANOTHER_FOR_OR" : "o",
  "FORGOT_PASSWORD_SUCCESSFULLY": "Tu nueva contraseña ha sido creada.",
  "THANKS_FOR_UPDATING_YOUR_ODOMETER": "Gracias por actualizar tu odómetro.",
  "MILEAGE":"Kilometraje",
  "AUTO_PAY": "Pago automático",
  "MORTGAGE_BILLED": "Hipoteca facturada",
  "CHANGE_ADDRESS_RESIDENTIAL": "Actualizar direccion residencial",
  "UPDATE_ADDRESS": "Dirección de actualización",
  "NUMBER_AND_STREET": "Número / Calle",
  "CONTACT_YOUR_BILLING_REPRESENTATIVE" : "Póngase en contacto con su representante de facturación",
  "PAYMENT_SUCCESS": "Gracias por tu pago.",
  "NEW_PARKING_LOCATION_INFO": "Este cambio será referido para una revisión adicional.",
  "WELCOME_FIRST_TIME": "¡Bienvenido a su cuenta de seguro MAPFRE!",
  "ENTER_YOUR_CURRENT_PASSWORD": "introduce tu contraseña actual",
  "ENTER_A_VALID_PASSWORD" : "Ingrese una contraseña válida",
  "CONFIRM_BUTTON": "CONFIRMAR",
  "CHANGE_PASSWORD_BUTTON": "CAMBIAR CONTRASEÑA",
  "SAVE_TIME_EACH_MONTH": "Ahorra Tiempo Cada Mes",
  "EMAIL_IN_USE" : "El correo electrónico ya está en nosotros",
  "EMAIL_MISMATCH": "el email no coincide",
  "EMAIL_UPDATE_SUCCESSFUL": "Tu email fue actualizado exitosamente",
  "ADD_CHECKING_SAVING_ACCOUNT": "Añadir cuenta de cheques / ahorro",
  "UPDATE_CHECKING_SAVING_ACCOUNT": "Actualizar cuenta de cheques / ahorro",
  "ADD_ACCOUNT": "AÑADIR CUENTA",
  "UPDATE_ACCOUNT": "ACTUALIZAR CUENTA",
  "REMOVE_CHECKING_ACCOUNT_MSG_1" : "¿Está seguro de que desea eliminar su cuenta de cheques / ahorro?",
  "REMOVE_CHECKING_ACCOUNT_MSG_2" : "de tu cuenta?",
  "KEEP_BANK_ACCOUNT": "MANTENER LA CUENTA BANCARIA",
  "BANK_ACCOUNT_REMOVED": "Cuenta bancaria eliminada exitosamente",
  "BANK_ACCOUNT_ADDED" : "Cuenta bancaria agregada exitosamente",
  "BANK_ACCOUNT_UPDATED" : "Cuenta bancaria actualizada exitosamente",
  "EMAIL_EBILL": "Email para enviar notificaciones",
  "POLICY_ADDEDD_SUCCESSFULLY": "Política agregada exitosamente!",
  "POLICY_ADDITION_ERROR":  "Política no añadida",
  "EMAIL_SUCCESSFULLY_CHANGED": "Correo electrónico cambiado con éxito.",
  "ENROLL": "INSCRIBIRSE",
  "DEDUCTION_DATE_MESSAGE": "Solo puede editar la fecha 3 veces en un término de política.",
  "VALID_PHONE_NUMBER":"Formato de teléfono incorrecto",
  "PHONE_ADDED_SUCCESSFULLY":"Número de teléfono agregado correctamente",
  "PHONE_UPDATED_SUCCESSFULLY":"Número de teléfono actualizado correctamente",
  "ADD_PHONE_BUTTON": "AGREGAR EL NÚMERO DE TELÉFONO",
  "UPDATE_PHONE_BUTTON": "Teléfono de actualización",
  "CONTACT_YOUR_AGENT": "Contacta a tu agente",
  "BANK_ACCOUNT_HOLDERS_NAME": "Nombre del propietario de la cuenta bancaria",
  "ROUTING_ABA_NUMBER": "Número de enrutamiento / ABA",
  "NOT_ELEGIBLE_EPOLICY": "No elegible para la política electrónica",
  "NOT_ELEGIBLE_EPAY": "No elegible para pago electrónico",
  "NOT_ELEGIBLE_EBILL": "No elegible para factura electrónica",
  "VIEW": "VER",
  "MAKE_A_PAYMENT": "Realizar un pago",
  "CONTACT_CENTER_HOURS":"8am a 6pm (EST) de lunes a viernes",
  "TO_MAIL_A_PAYMENT_OR_CORRESPONDENCE":"Para enviar un pago o correspondencia",
  "COMPANY_NAME":"Seguro de comercio",
  "ADDRESS_PART_ONE":"11 Gore Road",
  "ADDRESS_PART_TWO":"Webster, MA 01570",
  "TERMS_AND_CONDITIONS": "He leído y acepto los términos a continuación.",
  "PLEASE_CONFIRM": "Por favor confirmar",
  "CONFIRM_LANGUAGE": "Confirmar idioma",
  "SAVE_NEW_ADDRESS": "Guardar nueva direccion",
  "FORGOT_EMAIL_SUBJECT_LINE": "Seguro MAPFRE - IMPORTANTE - Restablece tu contraseña",
  "WALLET_TITLE_ONE": "Conseguir su",
  "WALLET_TITLE_TWO": "Nunca perderás los detalles de tu póliza",
  "WALLET_TITLE_THREE": "Aprovecha tu tarjeta",
  "WALLET_CONTENT_ONE": "Conozca los beneficios de mantener la información de su póliza en una tarjeta de billetera digital.",
  "WALLET_CONTENT_TWO": "Con una tarjeta de billetera digital, su información está siempre a su alcance!",
  "WALLET_CONTENT_THREE": "Puede presentar un reclamo, contactar a su agente, acceder a los detalles de su póliza en cualquier momento",
  "WALLET_GET_MY_CARD": "Obtener mi tarjeta",
  "WALLET_SKIP": "Saltar por ahora",
  "ADDRESS_APT": "Apartamento (opcional)",
  "CLAIM_INFO": "Para pérdidas por 'colisión', se puede aplicar un recargo dependiendo de quién es responsable del accidente.",
  "EBILL_ENROLL": "Te has inscrito en e-bill. El proceso puede demorar hasta 2 días.",
  "EBILL_CANCEL": "Has cancelado EBill. El proceso puede demorar hasta 2 días.",
  "EPAY_ENROLL": "Felicidades Te has inscrito!",
  "EPAY_CANCEL": "Has cancelado e-Pay. El proceso puede demorar hasta 2 días.",
  "EPAY_ENROLL_ERROR": "Lo sentimos, hubo un problema y no pudimos inscribirte.",
  "EPOLICY_ENROLL": "Usted se ha inscrito en la política electrónica. El proceso puede demorar hasta 2 días.",
  "EPOLICY_CANCEL": "Has cancelado la política electrónica. El proceso puede demorar hasta 2 días.",
  "PROBLEM_IN_REQUEST_PROCESSING": "Hubo un problema al procesar su solicitud. Por favor, inténtelo de nuevo más tarde.",
  "VERIFICATION_EMAIL_SENT": "El mensaje de verificación ha sido enviado.",
  "VERIFICATION_EMAIL_ERROR": "Hubo un problema para enviar el correo electrónico de verificación.",
  "MILEAGE_MAX_LIMIT": "Por favor, introduzca un valor inferior a 1000000.",
  "VALUE_LESS_THAN_ORIGINAL": "El valor que ha introducido es menor que el original.",
  "PLEASE_UPDATE_MILEAGE": "Por favor, actualice el kilometraje.",
  "PROBLEM_UPDATING_MILEAGE": "Hubo un problema al actualizar su kilometraje.",
  "RESIDENTIAL_GARAGE": "¿Se guardarán todos sus vehículos en esta nueva ubicación?",
  "CHANGE_ADDRESS_MAILING": "Cambiar dirección de correo",
  "CLAIM_DETAIL_TOOLTIP": "Para pérdidas por 'colisión', se puede aplicar un recargo dependiendo de quién es responsable del accidente.",
  "CONTACT_US": "Contáctenos",
  "BAD_REQUEST": "Solicitud incorrecta",
  "ERROR_400": "El enlace en el que hizo clic puede estar roto o la página puede haber sido eliminada",
  "AUTHORIZATION_NEEDED": "Autorización necesaria",
  "ERROR_401": "Lo sentimos, no pudimos verificar que está autorizado para acceder a esta página.",
  "FORBIDDEN": "Prohibido",
  "ERROR_403": "Lo sentimos, no tienes permiso para acceder a esta página.",
  "PAGE_NOT_FOUND": "Página no encontrada",
  "ERROR_404": "El enlace en el que hizo clic puede estar roto, o la página puede haber sido eliminada.",
  "REQUEST_TIMED_OUT": "Tiempo de espera agotado",
  "ERROR_408":"Esta página tomó demasiado tiempo para cargar.",
  "GONE": "ido",
  "ERROR_410": "El enlace en el que hizo clic puede estar roto, o la página puede haber sido eliminada.",
  "INTERNAL_SERVER_ERROR": "Error de servidor interno",
  "ERROR_500": "Lo sentimos, el servidor encontró un error y no pudo completar su solicitud.",
  "BAD_GATEWAY": "Puerta de enlace mal",
  "ERROR_502": "Lo sentimos, nos encontramos con un error temporal. Inténtalo de nuevo.",
  "TEMPORARILY_UNAVAILABLE": "Temporalmente no disponible",
  "ERROR_503": "Lo sentimos, nos encontramos con un error temporal. Inténtalo de nuevo.",
  "GATEWAY_TIMEOUT": "Tiempo de espera de la puerta de enlace",
  "ERROR_504": "Lo sentimos, nos encontramos con un error temporal. Inténtalo de nuevo.",
  "CHECKING": "Comprobación",
  "SAVING": "Ahorros",
  "ROUTING_NUMBER_VALIDATION": "Proporcionar un número de enrutamiento válido.",
  "WALLETBACK_TITLE":"¡Descargar ahora!",
  "WALLETBACK_ANDROID": "Por ahora, los usuarios de Android necesitarán la aplicación WalletPasses para guardarla.",
  "WALLETBACK_WALLETPASS": "Descargar WalletPasses",
  "EPAY_EDIT_ENROLL_PARA": "Edite la información de la cuenta bancaria vinculada a su política. Es posible que necesitemos hasta 15 días para procesar los cambios solicitados.",
  "THANKS_FOR_VALIDATING_ACCOUNT": "Gracias por validar tu cuenta!",
  "YES": "Sí",
  "NO": "No",
  "FULLY_ENROLLED_IN_PAPERLESS":"Estás totalmente inscrito en Paperless",
  "NO_POLICY_IN_PAPERLESS": "Usted no tiene ninguna política elegible para Paperless.",
  "DATE_BILLED": "Fecha de facturación",
  "THIS_VEHICLE_IS_NOT_ELIGIBLE": "La actualización del odómetro no está disponible",
  "SEE_OUR_HELP_SECTION":"Vea nuestra sección de ayuda.",
  "CLAIM_FAQ_5B": "aprender más.",
  "UMBRELLA": "Paraguas",
  "SCHEDULED_PROPERTY": "Propiedad programada",
  "GARAGE_KEEPER": "Encargado del garaje",
  "DWELLING_FIRE_PERSONAL": "Vivienda Fuego Personal",
  "GENERAL_LIABILITY": "Responsabilidad general",
  "COMMERCIAL_AUTO": "Auto Comercial",
  "SPECIAL_MULTI_PERIL": "Multi peligro especial",
  "COMMERCIAL_FIRE": "Fuego comercial",
  "UPDATE_PENDING": "Actualización pendiente",
  "CLASSIC_FORMAT": "Formato clásico",
  "NEW_FORMAT": "Nuevo formato",
  "ENROLL_IN_PROGRAM": "¡Inscríbete en nuestro programa Paperless!",
  "YOUR_POLICIES": "Tus politicas",
  "PAPERLESS_DISCOUNT_AVAILABLE": "¡Descuento sin papel disponible!",
  "PAST_POLICIES": "Políticas pasadas",
  "REMOVE_POLICY_FROM_PAPERLESS": "Usted está a punto de eliminar su póliza de sin papel. Estás seguro de que quieres continuar?",
  "REMOVE_POLICY": "retirar",
  "MANAGE_PAYMENT_METHOD": "Administrar los métodos de pago",
  "MANAGE": "Gestionar",
  "AUTOPAY_TEXT":"Configure el pago automático y nunca tendrá que preocuparse por recordar pagar nuevamente su factura.",
  "AUTOPAY_ENROLL_TITLE": "Matrícula automática",
  "FROM_AUTOPAY": "de pago automático",
  "REMOVE_FROM_AUTOPAY": "Eliminar de pago automático",
  "RESIDENTIAL_ADDRESS_TEXT": "La nueva dirección residencial actualizará la dirección de garaje de todos sus vehículos. Si esto no aplica, por favor",
  "CONTACT_AGENT": "póngase en contacto con su agente.",
  "PO_BOX_ADDRESS": "Dirección de apartado postal"
}